"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentsScoreDistributionPerformanceClassSerializer = exports.StudentsScoreDistributionPerformanceSerializer = exports.AssessmentsAverageScoreByItemSerializer = exports.AverageScoreClassAvrByItemSerializer = exports.AverageScoreClassAvrSerializer = exports.AverageScoreSchoolAvrSerializer = exports.AverageSummaryAvrSerializer = exports.AdminAssessmentListSerializer = void 0;
var models_1 = require("../../models");
var AdminAssessmentListSerializer = /** @class */ (function () {
    function AdminAssessmentListSerializer() {
    }
    AdminAssessmentListSerializer.prototype.serialize = function (_a) {
        var templateId = _a.templateId, title = _a.title, score = _a.score, maxScore = _a.maxScore, percentage = _a.percentage, schoolCount = _a.schoolCount, classCount = _a.classCount, teacherCount = _a.teacherCount;
        return new models_1.AdminAssessmentList({
            templateId: templateId,
            title: title,
            score: score,
            maxScore: maxScore,
            percentage: percentage,
            schoolCount: schoolCount,
            classCount: classCount,
            teacherCount: teacherCount,
        });
    };
    return AdminAssessmentListSerializer;
}());
exports.AdminAssessmentListSerializer = AdminAssessmentListSerializer;
var AverageSummaryAvrSerializer = /** @class */ (function () {
    function AverageSummaryAvrSerializer() {
    }
    AverageSummaryAvrSerializer.prototype.serialize = function (_a) {
        var score = _a.score, maxScore = _a.maxScore, percentage = _a.percentage, schoolCount = _a.schoolCount, studentCount = _a.studentCount, teacherCount = _a.teacherCount, classCount = _a.classCount;
        return new models_1.AverageSummaryAvr({
            score: score,
            maxScore: maxScore,
            percentage: percentage,
            schoolCount: schoolCount,
            studentCount: studentCount,
            teacherCount: teacherCount,
            classCount: classCount,
        });
    };
    return AverageSummaryAvrSerializer;
}());
exports.AverageSummaryAvrSerializer = AverageSummaryAvrSerializer;
var themeBands = {
    'Not Yet Proficient': 'NotProficient',
    Proficient: 'Proficient',
    'Partially Proficient': 'PartiallyProficient',
    'Highly Proficient': 'HighlyProficient',
};
var AverageScoreSchoolAvrSerializer = /** @class */ (function () {
    function AverageScoreSchoolAvrSerializer() {
    }
    AverageScoreSchoolAvrSerializer.prototype.serialize = function (_a) {
        var schoolId = _a.schoolId, schoolName = _a.schoolName, score = _a.score, maxScore = _a.maxScore, percentage = _a.percentage, performance = _a.performance;
        return new models_1.AverageScoreSchoolAvr({
            schoolId: schoolId,
            schoolName: schoolName,
            score: score,
            maxScore: maxScore,
            percentage: percentage,
            performance: themeBands[performance],
        });
    };
    return AverageScoreSchoolAvrSerializer;
}());
exports.AverageScoreSchoolAvrSerializer = AverageScoreSchoolAvrSerializer;
var AverageScoreClassAvrSerializer = /** @class */ (function () {
    function AverageScoreClassAvrSerializer() {
    }
    AverageScoreClassAvrSerializer.prototype.serialize = function (_a) {
        var schoolId = _a.schoolId, schoolName = _a.schoolName, classId = _a.classId, className = _a.className, score = _a.score, maxScore = _a.maxScore, percentage = _a.percentage, performance = _a.performance;
        return new models_1.AverageScoreClassAvr({
            schoolId: schoolId,
            schoolName: schoolName,
            classId: classId,
            className: className,
            score: score,
            maxScore: maxScore,
            percentage: percentage,
            performance: themeBands[performance],
        });
    };
    return AverageScoreClassAvrSerializer;
}());
exports.AverageScoreClassAvrSerializer = AverageScoreClassAvrSerializer;
var AverageScoreClassAvrByItemSerializer = /** @class */ (function () {
    function AverageScoreClassAvrByItemSerializer() {
    }
    AverageScoreClassAvrByItemSerializer.prototype.serialize = function (_a) {
        var schoolId = _a.schoolId, schoolName = _a.schoolName, classId = _a.classId, className = _a.className, score = _a.score, maxScore = _a.maxScore, percentage = _a.percentage, items = _a.items, teacherEmail = _a.teacherEmail, teacherFirstName = _a.teacherFirstName, teacherLastName = _a.teacherLastName, totalClassStudents = _a.totalClassStudents;
        return new models_1.ScoreByItemClassAvr({
            schoolId: schoolId,
            schoolName: schoolName,
            classId: classId,
            className: className,
            score: score,
            maxScore: maxScore,
            percentage: percentage,
            teacherEmail: teacherEmail,
            teacherFirstName: teacherFirstName,
            teacherLastName: teacherLastName,
            totalClassStudents: totalClassStudents,
            items: (items || []).map(function (item) {
                return new models_1.ScoreRawItemClass({
                    itemExternalId: item.itemExternalId,
                    itemScore: item.itemScore,
                    itemMaxScore: item.itemMaxScore,
                    itemPercentage: item.itemPercentage,
                    itemOrder: item.itemOrder,
                    itemType: item.itemType,
                });
            }),
        });
    };
    return AverageScoreClassAvrByItemSerializer;
}());
exports.AverageScoreClassAvrByItemSerializer = AverageScoreClassAvrByItemSerializer;
var AssessmentsAverageScoreByItemSerializer = /** @class */ (function () {
    function AssessmentsAverageScoreByItemSerializer() {
    }
    AssessmentsAverageScoreByItemSerializer.prototype.serialize = function (_a) {
        var schoolId = _a.schoolId, schoolName = _a.schoolName, score = _a.score, maxScore = _a.maxScore, percentage = _a.percentage, scoreWeight = _a.scoreWeight, items = _a.items;
        return new models_1.ScoreByItemAvr({
            schoolId: schoolId,
            schoolName: schoolName,
            score: score,
            maxScore: maxScore,
            percentage: percentage,
            scoreWeight: scoreWeight,
            items: (items || []).map(function (item) {
                return new models_1.ScoreRawItem({
                    itemExternalId: item.itemExternalId,
                    itemScore: item.itemScore,
                    itemMaxScore: item.itemMaxScore,
                    itemPercentage: item.itemPercentage,
                    itemOrder: item.itemOrder,
                    itemType: item.itemType,
                    itemScoreWeight: item.itemScoreWeight,
                });
            }),
        });
    };
    return AssessmentsAverageScoreByItemSerializer;
}());
exports.AssessmentsAverageScoreByItemSerializer = AssessmentsAverageScoreByItemSerializer;
var StudentsScoreDistributionPerformanceSerializer = /** @class */ (function () {
    function StudentsScoreDistributionPerformanceSerializer() {
    }
    StudentsScoreDistributionPerformanceSerializer.prototype.serialize = function (_a) {
        var schoolId = _a.schoolId, schoolName = _a.schoolName, score = _a.score, maxScore = _a.maxScore, percentage = _a.percentage, rest = __rest(_a, ["schoolId", "schoolName", "score", "maxScore", "percentage"]);
        return new models_1.StudentDistributionAvr(__assign({ schoolId: schoolId, schoolName: schoolName, score: score, maxScore: maxScore, percentage: percentage }, rest));
    };
    return StudentsScoreDistributionPerformanceSerializer;
}());
exports.StudentsScoreDistributionPerformanceSerializer = StudentsScoreDistributionPerformanceSerializer;
var StudentsScoreDistributionPerformanceClassSerializer = /** @class */ (function () {
    function StudentsScoreDistributionPerformanceClassSerializer() {
    }
    StudentsScoreDistributionPerformanceClassSerializer.prototype.serialize = function (_a) {
        var schoolId = _a.schoolId, schoolName = _a.schoolName, classId = _a.classId, className = _a.className, score = _a.score, maxScore = _a.maxScore, percentage = _a.percentage, rest = __rest(_a, ["schoolId", "schoolName", "classId", "className", "score", "maxScore", "percentage"]);
        return new models_1.StudentDistributionClassAvr(__assign({ classId: classId, className: className, schoolId: schoolId, schoolName: schoolName, score: score, maxScore: maxScore, percentage: percentage }, rest));
    };
    return StudentsScoreDistributionPerformanceClassSerializer;
}());
exports.StudentsScoreDistributionPerformanceClassSerializer = StudentsScoreDistributionPerformanceClassSerializer;
